/* CHYRONYX — Gold Cursor Engine (Resilient, Smooth & Responsive) */
(function(){
  var dot = document.querySelector('.gold-cursor');
  var ring = document.querySelector('.gold-cursor-ring');
  if (!dot || !ring) return;

  var mouseX = -100, mouseY = -100;
  var ringX = -100, ringY = -100;
  var hasMoved = false;

  window.addEventListener('mousemove', function(e){
    mouseX = e.clientX;
    mouseY = e.clientY;
    if (!hasMoved) {
      ringX = mouseX;
      ringY = mouseY;
      hasMoved = true;
    }
    dot.style.left = mouseX + 'px';
    dot.style.top = mouseY + 'px';
    dot.style.opacity = '1';
    ring.style.opacity = '1';
  }, { passive: true });

  // Smooth ring follow loop
  function renderRing() {
    if (hasMoved) {
      ringX += (mouseX - ringX) * 0.28;
      ringY += (mouseY - ringY) * 0.28;
      ring.style.left = ringX + 'px';
      ring.style.top = ringY + 'px';
    }
    requestAnimationFrame(renderRing);
  }
  requestAnimationFrame(renderRing);

  document.addEventListener('mouseleave', function(){
    dot.style.opacity = '0';
    ring.style.opacity = '0';
  });

  document.addEventListener('mouseenter', function(e){
    mouseX = e.clientX;
    mouseY = e.clientY;
    dot.style.opacity = '1';
    ring.style.opacity = '1';
  });

  // Interactive hover expansion on buttons, cards, links
  document.addEventListener('mouseover', function(e){
    var target = e.target;
    if (target && target.closest && target.closest('button, a, [role="button"], .cy-card, .pcard, .marquee-game-trigger, .nav-minigame-btn, .cy-btn-beige, .cy-btn-outline')) {
      ring.style.width = '46px';
      ring.style.height = '46px';
      ring.style.borderColor = 'rgba(200, 164, 72, 0.85)';
      ring.style.backgroundColor = 'rgba(200, 164, 72, 0.1)';
    }
  });

  document.addEventListener('mouseout', function(e){
    var target = e.target;
    if (target && target.closest && target.closest('button, a, [role="button"], .cy-card, .pcard, .marquee-game-trigger, .nav-minigame-btn, .cy-btn-beige, .cy-btn-outline')) {
      ring.style.width = '32px';
      ring.style.height = '32px';
      ring.style.borderColor = 'rgba(200, 164, 72, 0.45)';
      ring.style.backgroundColor = 'transparent';
    }
  });
})();

/* Native dialogs occupy the top layer. Keep the existing gold cursor in that same layer. */
(()=>{const dot=document.querySelector('.gold-cursor'),ring=document.querySelector('.gold-cursor-ring');if(!dot||!ring)return;const selectors='#chx-pair-picker,#chx-cart-pair-picker';function sync(){const opened=Array.from(document.querySelectorAll(selectors)).filter(d=>d.open),parent=opened[opened.length-1]||document.body;for(const node of [dot,ring]){if(node.parentElement!==parent)parent.appendChild(node);}}const watch=new MutationObserver(sync);document.querySelectorAll(selectors).forEach(d=>watch.observe(d,{attributes:true,attributeFilter:['open']}));sync();})();
